import React from 'react'
function DailyReports() {

    return (
        <div>DailyReports</div>
    );
}

export default DailyReports;